export const ABLE_PLAN = 'medicationLoseWeight';
